import { css, StyleSheet } from "aphrodite";

import Image from "~/components/Image";

import { COLORS } from "../../../config/themes";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimer } from "@fortawesome/pro-light-svg-icons";

const RespondsIn = ({ responseTime, highlight }) => {
  return (
    <>
      {responseTime && (
        <div className={css(styles.responseInfo)}>
          <FontAwesomeIcon
            icon={faTimer}
            style={{
              color: "rgb(4, 120, 87)",
              fontSize: 14,
              background: "transparent",
            }}
          />
          {/* <Image
            className={css(styles.clock)}
            imageSrc="/static/response_clock.svg"
            defaultSrc="/static/response_clock.svg"
            containerClassName={css(styles.imageContainer)}
          /> */}
          <span className={css(styles.responseText)}>
            Usually responds in{" "}
            <span className={css(styles.responseHighlight, highlight)}>
              {responseTime ? responseTime.replace(/Min/i, "minute") : "N/A"}
            </span>
          </span>
        </div>
      )}
    </>
  );
};

const styles = StyleSheet.create({
  responseInfo: {
    display: "flex",
    alignItems: "center",
  },
  responseHighlight: {
    color: COLORS.GREEN(),
  },
  responseText: {
    fontSize: 15,
    lineHeight: "24px",
    fontWeight: 400,
    marginLeft: 8,

    "@media only screen and (max-width: 1023px)": {
      marginLeft: 6,
    },
  },
  imageContainer: {
    width: 15,
    height: 15,
    marginLeft: 0,
    marginTop: 4,
  },
});
export default RespondsIn;
